/**
 * World entity schema
 */

import { z } from 'zod';
import { WorldStatusSchema } from '../enums';

export const WorldSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  durable_object_id: z.string(),
  title: z.string(),
  simulation_type: z.enum(['narrative', 'companion']),
  status: WorldStatusSchema,
  current_arc_id: z.string().nullable(),
  current_chapter_id: z.string().nullable(),
  player_character_id: z.string().nullable(),
  message_count: z.number().int().nonnegative(),
  created_at: z.string(),
  updated_at: z.string(),
  last_accessed_at: z.string().nullable().optional(),
  /** The world and message this one was branched from. */
  branched_from_world_id: z.string().nullable().optional(),
  branched_from_message_id: z.string().nullable().optional(),
});

export type World = z.infer<typeof WorldSchema>;
